var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdditionalDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "37.5pt",
    height: "37.499999pt",
    viewBox: "0 0 37.5 37.499999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 37.007812 0 L 37.007812 37.007812 L 0 37.007812 Z M 0 0 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.386719 12.929688 L 32.667969 12.929688 L 32.667969 30.40625 L 4.386719 30.40625 Z M 4.386719 12.929688 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13 0.425781 L 24 0.425781 L 24 11 L 13 11 Z M 13 0.425781 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.273438 18.621094 L 27.75 18.621094 L 27.75 37.007812 L 9.273438 37.007812 Z M 9.273438 18.621094 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0 0 L 37.5 0 L 37.5 37.5 L 0 37.5 Z M 0 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0 0 L 37.5 0 L 37.5 37.5 L 0 37.5 Z M 0 0 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 11.207031 14.613281 L 4.386719 25.722656 L 6.394531 30.402344 L 9.085938 30.40625 C 8.894531 29.632812 8.792969 28.824219 8.792969 27.992188 C 8.792969 23.0625 12.351562 19.035156 16.949219 18.273438 L 16.949219 18.238281 L 17.179688 18.238281 C 17.621094 18.175781 18.070312 18.144531 18.527344 18.144531 C 18.984375 18.144531 19.4375 18.175781 19.878906 18.238281 L 20.101562 18.238281 L 20.101562 18.273438 C 24.703125 19.03125 28.265625 23.0625 28.265625 27.992188 C 28.265625 28.824219 28.164062 29.632812 27.96875 30.40625 L 30.664062 30.402344 L 32.671875 25.722656 L 25.851562 14.613281 C 20.503906 12.394531 16.554688 12.394531 11.207031 14.613281 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 23.472656 5.445312 C 23.472656 2.6875 21.257812 0.449219 18.527344 0.449219 C 15.800781 0.449219 13.585938 2.683594 13.585938 5.445312 C 13.585938 8.199219 15.800781 10.4375 18.527344 10.4375 C 21.257812 10.4375 23.472656 8.199219 23.472656 5.445312 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 27.703125 27.992188 C 27.703125 22.871094 23.59375 18.71875 18.527344 18.71875 C 13.460938 18.71875 9.355469 22.871094 9.355469 27.992188 C 9.355469 33.105469 13.460938 37.261719 18.527344 37.261719 C 23.59375 37.261719 27.703125 33.105469 27.703125 27.992188 Z M 26.058594 27.992188 C 26.058594 32.191406 22.691406 35.601562 18.527344 35.601562 C 14.371094 35.601562 10.996094 32.191406 10.996094 27.992188 C 10.996094 23.789062 14.371094 20.378906 18.527344 20.378906 C 22.691406 20.378906 26.058594 23.789062 26.058594 27.992188 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 20.359375 27.992188 C 20.359375 26.96875 19.539062 26.136719 18.527344 26.136719 C 17.515625 26.136719 16.695312 26.96875 16.695312 27.992188 C 16.695312 29.011719 17.515625 29.839844 18.527344 29.839844 C 19.539062 29.839844 20.359375 29.011719 20.359375 27.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 17.515625 18.8125 L 19.539062 18.8125 L 19.539062 26.441406 C 19.253906 26.25 18.902344 26.136719 18.527344 26.136719 C 18.152344 26.136719 17.804688 26.25 17.515625 26.441406 L 17.515625 18.8125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 26.898438 31.691406 L 25.886719 33.464844 L 19.34375 29.648438 C 19.65625 29.488281 19.929688 29.242188 20.117188 28.914062 C 20.304688 28.585938 20.382812 28.226562 20.359375 27.871094 L 26.898438 31.691406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 11.171875 33.464844 L 10.15625 31.691406 L 16.699219 27.871094 C 16.675781 28.226562 16.753906 28.585938 16.941406 28.914062 C 17.128906 29.246094 17.402344 29.492188 17.710938 29.648438 L 11.171875 33.464844 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalDriver);
export default __webpack_public_path__ + "static/media/additional_driver.55e93b8010452c6abb43099ced98f04e.svg";
export { ForwardRef as ReactComponent };